import React, {Component} from '../../lib/react';
import {Button, Spin, message, Collapse, Input, Checkbox} from 'antd';

import { updateExistingEvent } from "../../services/firebase/events";
import { getAllVideosChannel, getAllPlaylistsChannel, postEditTitlePlaylist,
  postCreatePlaylistChannel, getAllVideosOfPlaylist, deleteVideoFromPlaylist,
  deletePlaylistChannel, putAddVideoToPlaylist } from '../../services/firebase/firebase';
import moment from 'moment';

import './videoManager.less';

const { Panel } = Collapse;

class VideoManager extends Component {
  constructor(props){
    super(props);

    this.state = {
      sending: false,
      loading: true,
      editingPlaylist: false,
      currentPlaylistVideos: [],
      creatingPlaylist: false,
      newPlaylistTitle: '',
      playlistContent: 'playlists', // possible: playlists || editPlaylist || createPlaylist
      videoContent: 'single',       // possible: single || playlist
      videoList: [],
      playlists: [],
    }
  }

  componentDidMount() {
    const { channel } = this.props;

    this.handleGetAllVideosChannel(channel);
    this.handleGetAllPlaylists(channel);
  }

  selectVideoContent(type) {
    this.setState({videoContent: type})
  }

  // Requests actions

  handleUpdatingEvent(type, eventContent, typeAction) {
    let updatedEvent = this.props.event;
    updatedEvent[type] = eventContent;

    this.setState({ loading: true });
    updateExistingEvent(updatedEvent, 'past')
      .then(() => {
        message.success(`Event updated! ${typeAction || 'Added'} ${type}`);

        this.setState({ loading: false });
      })
      .catch(e => message.error('Error', e))
  }

  handleGetAllVideosChannel(channel) {
    this.setState({ loading: true });
    channel && channel.id && getAllVideosChannel(channel)
      .then((res) => {
        res && res.videos && this.setState({ videoList: res.videos, loading: false })
      })
      .catch(e => message.error('Error', e))
  }

  handleGetAllPlaylists(channel) {
    this.setState({ loading: true });
    channel && channel.id && getAllPlaylistsChannel(channel)
      .then((res) => {
        res && res.playlists && this.setState({ playlists: res.playlists, loading: false })
      })
      .catch(e => message.error('Error', e))
  }

  handleGetAllVideosOfPlaylist(playlistId) {
    this.setState({ loadingVideosPlaylist: true });
    playlistId && getAllVideosOfPlaylist(playlistId)
      .then((res) => {
        this.setState({ loadingVideosPlaylist: false, currentPlaylistVideos: res && res.videos })
      })
      .catch(e => message.error('Error', e))
  }

  handleCreatePlaylist(channel) {
    this.setState({ creatingPlaylist: true });

    postCreatePlaylistChannel(channel, this.state.newPlaylistTitle)
      .then((res) => {
        if (!res.error) {
          message.success('Playlist created!');
          this.handleGetAllPlaylists(channel)
        } else {
          message.error(res.error)
        }
      })
      .then(() => {
        this.setState({ creatingPlaylist: false, playlistContent: 'playlists'});
      })
      .catch(e => message.error('Error', e))
  }

  async handleEditTitlePlaylist(editPlaylist, channel) {
    this.setState({ editingPlaylist: true });

    await editPlaylist && postEditTitlePlaylist(editPlaylist.id, this.state.newPlaylistTitle)
      .then((res) => {
        if (!res.error) {
          message.success("Playlist's title changed!");
          this.handleGetAllPlaylists(channel)
        } else {
          message.error(res.error)
        }
      })
      .then(() => {
        this.setState({ editingPlaylist: false });
      })
      .catch(e => message.error('Error', e))
  }

  handleDeletePlaylist(playlist, channel) {
    playlist && deletePlaylistChannel(playlist.id)
      .then((res) => {
        if (!res.error) {
          message.success('Playlist deleted!');
          this.handleGetAllPlaylists(channel);
        } else {
          message.error(res.error)
        }
      })
      .catch(e => message.error('Error', e))
  }

  handleAddVideoToPlaylist(playlistId, videoId) {
    this.setState({ editingPlaylist: true });
    putAddVideoToPlaylist(playlistId, videoId)
      .then((res) => {
        if (!res.error) {
          message.success('Video added to playlist!');
          this.setState({ editingPlaylist: false });
          this.handleGetAllVideosOfPlaylist(playlistId);
        } else {
          message.error(res.error)
        }
      })
      .catch(e => message.error('Error', e))
  }

  handleDeleteVideoFromPlaylist(playlistId, videoId) {
    this.setState({ editingPlaylist: true });
    deleteVideoFromPlaylist(playlistId, videoId)
      .then((res) => {
        if (!res.error) {
          message.success('Video deleted from playlist!');
          this.setState({ editingPlaylist: false });
          this.handleGetAllVideosOfPlaylist(playlistId);
        } else {
          message.error(res.error)
        }
      })
      .catch(e => message.error('Error', e))
  }

  // UI handlers actions
  handleChangePlaylistContent(type) {
    const { playlistContent } = this.state;
    if (playlistContent === "createPlaylist" || playlistContent === "editPlaylist") {
      this.setState({ playlistContent: 'playlists' })
    } else {
      this.setState({ playlistContent: type })
    }
  }

  collapseCallback(playlistId) {
    this.handleGetAllVideosOfPlaylist(playlistId)
  }

  async handleCheckbox(checker, videoItem, editPlaylist) {
    if (checker) { // add video to playlist
      videoItem && editPlaylist &&  await this.handleAddVideoToPlaylist(editPlaylist.id, videoItem.id);
    } else { // remove video from playlist
      videoItem && editPlaylist && await this.handleDeleteVideoFromPlaylist(editPlaylist.id, videoItem.id);
    }

  }

  handleEditPlaylist(playlistItem) {
    this.setState({playlistContent: 'editPlaylist', editPlaylist: playlistItem})
  }

  // Render blocks

  popupHeaderRender(videoContent) {
    return (
      <div className="popup-header">
        <div
          className={`popup-header-btn ${videoContent === 'single' ? 'active' : ''}`}
          onClick={() => this.selectVideoContent('single')}
        >
          Single Video
        </div>
        <div
          className={`popup-header-btn ${videoContent === 'playlist' ? 'active' : ''}`}
          onClick={() => this.selectVideoContent('playlist')}
        >
          Playlists
        </div>
      </div>
    )
  }

  buttonControlRender(playlistItem, isSelectedPlaylist) {
    return (
      <div>
        {
          isSelectedPlaylist ? (
            <Button
              className="btn-danger"
              disabled={false}
              onClick={() => {
                event.stopPropagation();
                this.handleUpdatingEvent('playlist', null, 'Deleted');
              }}
            >
              Delete from Event
            </Button>
          ) : (
            <Button
              className="btn"
              disabled={isSelectedPlaylist}
              onClick={(event) => {
                event.stopPropagation();
                this.handleUpdatingEvent('playlist', playlistItem, 'Added');
              }}
            >
              Add to Event
            </Button>
          )
        }
      </div>
    )
  };

  playlistsViewRender(event, playlists, channel) {
    const { loadingVideosPlaylist, currentPlaylistVideos } = this.state;

    return (
      <div className="playlists-list">
        <Collapse
          accordion
          onChange={(key) => this.collapseCallback(key)}
          expandIconPosition={'left'}
        >
          {
            playlists.length > 0 && (
              playlists.map((playlistItem) => {
                const playlistMinutes = playlistItem.total_duration && (playlistItem.total_duration/60).toFixed(2);
                const isSelectedPlaylist = event && event.playlist && event.playlist.id === playlistItem.id;
                let playlistCreated = 'date';

                if (playlistItem && playlistItem.created_at) {
                  playlistCreated = moment(+`${playlistItem.created_at}000`).format('MM/DD/YYYY LT')
                }

                return (
                  <Panel
                    header={playlistItem.title}
                    key={playlistItem.id}
                    extra={this.buttonControlRender(playlistItem, isSelectedPlaylist)}
                  >
                    <div
                      className={`playlist-desc ${isSelectedPlaylist ? 'active': ''}`}
                    >
                      <div className="playlist-desc-top">
                        <p>Playlist title: <span>{playlistItem.title}</span></p>
                        <p className="content-center">Created: <span>{playlistCreated}</span></p>
                        <p className="content-center">Total duration: <span>{playlistMinutes} min</span></p>
                      </div>
                      <div className="playlist-desc-controls">
                        <Button
                          className="btn-warning"
                          disabled={false}
                          onClick={() => {
                            this.handleEditPlaylist(playlistItem);
                          }}
                        >
                          Edit playlist
                        </Button>

                        <Button
                          className="btn-danger"
                          disabled={isSelectedPlaylist}
                          onClick={() => {
                            this.handleDeletePlaylist(playlistItem, channel);
                          }}
                        >
                          Delete from Ustream
                        </Button>
                      </div>
                    </div>
                    <div className="video-table-header">
                      <p>Title</p>
                      <p>Date</p>
                      <p>Length</p>
                    </div>
                    <div>
                      {
                        loadingVideosPlaylist ? (
                          this.preloaderRender()
                        ) : (
                          <div>
                            {
                              currentPlaylistVideos.map((videoItem) => {
                                return videoItem && this.videoItemRender(event, videoItem, 'playlist')
                              })
                            }
                          </div>
                        )
                      }
                    </div>
                  </Panel>
                )
              })
            )
          }
        </Collapse>
      </div>
    )
  }

  videoItemRender(event, videoItem, viewType) {
    const { currentPlaylistVideos, editPlaylist, loadingVideosPlaylist, editingPlaylist} = this.state;
    const videoMinutes = videoItem.length && (videoItem.length/60).toFixed(2);
    const isSelectedVideo = event && event.videoEmbed && event.videoEmbed.id === videoItem.id;

    let videoDate = 'date';

    if (videoItem.added_at) {
      videoDate = moment(+`${videoItem.added_at}000`).format('MM/DD/YYYY LT')
    }

    let isVideoInPlaylist = currentPlaylistVideos && currentPlaylistVideos.find((insideItem) => {
      return insideItem.id === videoItem.id
    });

    return (
      <div
        key={videoItem.id}
        className={`video-item ${isSelectedVideo ? 'active': ''}`}
      >
        {
          viewType === 'editPlaylist' && (
            <Checkbox
              key={videoItem.id}
              disabled={editingPlaylist || loadingVideosPlaylist}
              checked={!!isVideoInPlaylist}
              onChange={(e) => this.handleCheckbox(e.target.checked, videoItem, editPlaylist)}
            />
          )
        }
        <p>{videoItem.title}</p>
        <p className="content-center">{videoDate}</p>
        <p className="content-center">{videoMinutes}</p>
        {
          viewType === 'videoList' && (
            isSelectedVideo ? (
              <Button
                className="btn-danger"
                disabled={false}
                onClick={() => this.handleUpdatingEvent('videoEmbed', null, 'Deleted')}
              >
                Remove from event
              </Button>
            ) : (
              <Button
                className="btn"
                disabled={isSelectedVideo}
                onClick={() => this.handleUpdatingEvent('videoEmbed', videoItem, 'Added')}
              >
                Add
              </Button>
            )
          )
        }
      </div>
    )
  }

  playlistCreateRender(channel) {
    return (
      <div className="playlist-create">
        <Input
          className='input'
          type="playlist"
          id="playlist-field"
          placeholder="Playlist title"
          required="required"
          value={this.state.newPlaylistTitle}
          onChange={value => this.setState({ newPlaylistTitle: value.target.value })}
        />
        <Button
          className="btn"
          disabled={this.state.newPlaylistTitle.length === 0}
          onClick={() => {
            this.handleCreatePlaylist(channel);
          }}
        >
          Create playlist
        </Button>
      </div>
    )
  }

  editPlaylistRender() {
    const { videoList, editingPlaylist, loadingVideosPlaylist } = this.state;
    return (
      <div className="playlist-edit">
        {/*<h6>Edit playlist</h6>*/}
        {/*<div className="playlist-edit-form">*/}
          {/*<Input*/}
            {/*className='input'*/}
            {/*type="playlist"*/}
            {/*id="playlist-field"*/}
            {/*placeholder="Playlist title"*/}
            {/*required="required"*/}
            {/*value={this.state.newPlaylistTitle}*/}
            {/*onChange={value => this.setState({ newPlaylistTitle: value.target.value })}*/}
          {/*/>*/}
          {/*<Button*/}
            {/*className="btn"*/}
            {/*disabled={this.state.newPlaylistTitle.length === 0}*/}
            {/*onClick={() => {*/}
              {/*this.handleEditTitlePlaylist(editPlaylist, channel);*/}
            {/*}}*/}
          {/*>*/}
            {/*Edit title*/}
          {/*</Button>*/}
        {/*</div>*/}
        <h6>Choose videos</h6>
        <div className="playlist-consist">
          {
            videoList && videoList.map((videoItem) => {
              return this.videoItemRender(event, videoItem, 'editPlaylist')
            })
          }
          {
            (editingPlaylist || loadingVideosPlaylist) && (
              this.preloaderRender()
            )
          }
        </div>
      </div>
    )
  }

  preloaderRender() {
    return (
      <div className="preloader-wr">
        <Spin className="preloader" />
      </div>
    )
  }

  render() {
    const { event, channel } = this.props;
    const { videoList, playlists, loading, videoContent, playlistContent, creatingPlaylist } = this.state;
    let eventDate = event && event.date ? moment(event.date).format('MM/DD/YYYY LT') : 'date';
    let isPlaylistForm = playlistContent === "createPlaylist" || playlistContent === "editPlaylist" ;

    if (loading) {
      this.preloaderRender()
    }

    return (
      <div className="video-popup">
        {
          this.popupHeaderRender(videoContent)
        }
        {
          videoContent === 'single' && (
            <React.Fragment>
              <div className="popup-body-title">
                <h5>{`All videos of "${channel && channel.title}" channel`} (Event date: <span>{eventDate}</span>)</h5>
              </div>
              <div className="video-table-header">
                <p>Title</p>
                <p>Date</p>
                <p>Length</p>
              </div>
              <div className="single-list">
                {
                  videoList && videoList.length > 0 && (
                    videoList.map((videoItem) => {
                      return videoItem && this.videoItemRender(event, videoItem, 'videoList')
                    })
                  )
                }

                {
                  loading && this.preloaderRender()
                }
              </div>
            </React.Fragment>
          )
        }
        {
          videoContent === 'playlist' && (
            <React.Fragment>
              <div className="popup-body-title">
                <h5>{`All playlists of "${channel && channel.title}" channel`} (Event date: <span>{eventDate}</span>)</h5>
                <Button
                  className={`btn ${isPlaylistForm ? "" : "btn-success"}`}
                  disabled={false}
                  onClick={() => {
                    this.handleChangePlaylistContent('createPlaylist')
                  }}
                >
                  {isPlaylistForm ? "Cancel" : "Create"}
                </Button>
              </div>
              {
                playlistContent === "playlists" && playlists && (
                  this.playlistsViewRender(event, playlists, channel)
                )
              }
              {
                playlistContent === "createPlaylist" && (
                  this.playlistCreateRender(channel)
                )
              }
              {
                playlistContent === "editPlaylist" && (
                  this.editPlaylistRender()
                )
              }
              {
                creatingPlaylist && (this.preloaderRender())
              }
            </React.Fragment>
          )
        }
      </div>
    )
  }
}

export default VideoManager



// WEBPACK FOOTER //
// ./src/components/Modals/VideoManager.js